import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useScrollReveal from '../../hooks/useScrollReveal';
import '../../styles/ScrollReveal.css';

/**
 * ScrollManager Component
 * 
 * Sits in the root of the app and manages the scroll reveal effects
 * across route changes.
 */
const ScrollManager = () => {
    const { pathname, hash } = useLocation();

    useScrollReveal('.section, section, .hero, .footer, .services-page-grid, .portfolio-grid', pathname);

    useEffect(() => {
        if (hash) {
            const element = document.getElementById(hash.substring(1));
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        }
    }, [pathname, hash]);

    return null;
};

export default ScrollManager;
